var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('snapshot-check',{attrs:{"title":_vm.$it('inspection.detail.anomaly.manual-check.title', 'Serial number'),"type":_vm.type,"content":_vm.content}})}
var staticRenderFns = []

export { render, staticRenderFns }